jQuery(function($){
    
// Blog Feed - http://www.zazar.net/developers/jquery/zrssfeed/
// Blog News Ticker - http://www.jugbit.com/jquery-vticker-vertical-news-ticker/
$('#blogfeed').rssfeed('http://blog.tessuti.com.au/feed/',{
        limit: 8,
        header: false,
        media: true,
        date: false,
        titletag: 'h6',
        linktarget: '_blank',
    	snippet: true
	}, function(e) {
		$(e).find('div.rssBody').vTicker({
			speed: 1000,
            pause: 4000,
            showItems: 2,
            animation: 'fade',
            mousePause: true
		});
	});
    
$('#myTab-wrap ul.tabs').each(function(){
    // For each set of tabs, we want to keep track of
    // which tab is active and it's associated content
    var $active, $content, $links = $(this).find('a');

    // If the location.hash matches one of the links, use that as the active tab.
    // If no match is found, use the first link as the initial active tab.
    $active = $($links.filter('[href="'+location.hash+'"]')[0] || $links[0]);
    $active.addClass('active');
    $content = $($active.attr('href'));

    // Hide the remaining content
    $links.not($active).each(function () {
        $($(this).attr('href')).hide();
    });

    // Bind the click event handler
    $(this).on('click', 'a', function(e){
        // Make the old tab inactive.
        $active.removeClass('active');
        $content.hide();

        // Update the variables with the new link and content
        $active = $(this);
        $content = $($(this).attr('href'));

        // Make the tab active.
        $active.addClass('active');
        $content.show();

        // Prevent the anchor's default click action
        e.preventDefault();
    });
});

  $(".zoom-collection").on("mouseenter", ".single-product", function(){
    $(this).find(".prod-image").animate({height: '171px'}, 100); 
    $(this).find("img").animate({width: '270px'}, 200);
  });
  
  $(".zoom-collection").on("mouseleave", ".single-product", function(){
    $(this).find(".prod-image").animate({height: '150px'}, 100); 
    $(this).find("img").animate({width: '290px'}, 200);    
  });
  
  $(".pattern-collection").on("mouseenter", ".single-product", function(){
    $(this).find(".prod-image").animate({height: '335px'}, 100); 
    $(this).find("img").animate({width: '230px'}, 200);
  });
  
  $(".pattern-collection").on("mouseleave", ".single-product", function(){
    $(this).find(".prod-image").animate({height: '285px'}, 100); 
    $(this).find("img").animate({width: '270px'}, 200); 
  });
  
  
  
  

//$("label").inFieldLabels();


  // Molile Stylesheet - makes whole product box act as a link
$('div.featured-prod-item').click(function(){
 document.location.href = $(this).find('a:eq(0)').attr('href');
});

$('.single-product').click(function(){
 document.location.href = $(this).find('a:eq(0)').attr('href');
});

$('.locationLink ').click(function(){
 document.location.href = $(this).find('a:eq(0)').attr('href');
});

$('.icon-search').toggle(function() {
	$('#collapse-search').show(0);  
    $('#collapse-phone').hide(0); 
    $('#collapse-email').hide(0);
}, function() {
	$('#collapse-search').hide(0); 
    $('#collapse-phone').hide(0); 
    $('#collapse-email').hide(0);
});
$('.icon-phone').toggle(function() {
    $('#collapse-phone').show(0);  
    $('#collapse-search').hide(0);
    $('#collapse-email').hide(0);
}, function() {
	$('#collapse-phone').hide(0); 
    $('#collapse-search').hide(0); 
    $('#collapse-email').hide(0);
});
  
  
  $('.click_to_call_close').click(function(){
  	$('.icon-phone').trigger('click');
  	
  }); 
  
$('.icon-envelope').toggle(function() {
    $('#collapse-email').show(0); 
    $('#collapse-phone').hide(0);
    $('#collapse-search').hide(0); 
}, function() {
    $('#collapse-email').hide(0);
    $('#collapse-phone').hide(0);
    $('#collapse-search').hide(0); 
});

$('.icon-menu').toggle(function() {
    $('#collapse-menu').show(0); 
    $('#collapse-phone').hide(0);
    $('#collapse-search').hide(0); 
    $('#collapse-email').hide(0);
}, function() {
    $('#collapse-menu').hide(0);
    $('#collapse-phone').hide(0);
    $('#collapse-search').hide(0); 
    $('#collapse-email').hide(0);
});



  // Not on iPhone
if(!navigator.userAgent.match(/iPhone/i))
{
  // jquery prettyPhoto
  $("a[rel^='prettyPhoto']").prettyPhoto({
  theme: 'facebook', /* light_rounded / dark_rounded / light_square / dark_square / facebook */
  slideshow: false, /* false OR interval time in ms */
  autoplay_slideshow: false, /* true/false */
  allow_resize: true,
  deeplinking: false, /* Allow prettyPhoto to update the url to enable deeplinking. */
  social_tools: false,
  opacity: 0.95, /* Value between 0 and 1 */
  overlay_gallery: false, /* If set to true, a gallery will overlay the fullscreen image on mouse over */
  counter_separator_label: ' of ' /* The separator for the gallery counter 1 "of" 2 */
  });

  // jquery pick 
  jQuery('#frontpage-collection .featured-prod-item').pick(5);
  
  // stickem
  $('.container').stickem({
    start: 183,
    offset: 0
  });

  
}





    function megaHoverOver(){
    $(this).find(".sub").stop().fadeTo(0, 1, function() {
      $("#nav-block").stop(true, true).fadeIn();
    });
   
			
    //Calculate width of all ul's
    (function($) {
      jQuery.fn.calcSubWidth = function() {
        rowWidth = 0;
        //Calculate row
        $(this).find("ul").each(function() {
          rowWidth += $(this).width();
        });
      };
    })(jQuery);
		
    if ( $(this).find(".row").length > 0 ) { //If row exists...
      var biggestRow = 0;
      //Calculate each row
      $(this).find(".row").each(function() {
        $(this).calcSubWidth();
        //Find biggest row
        if(rowWidth > biggestRow) {
          biggestRow = rowWidth;
        }
      });
      //Set width
      $(this).find(".sub").css({
        'width' :biggestRow
      });
      $(this).find(".row:last").css({
        'margin':'0'
      });
			
    } else { //If row does not exist...
			
      $(this).calcSubWidth();
      //Set Width
      $(this).find(".sub").css({
        'width' : rowWidth
      });
			
    }
    
  }
	
  function megaHoverOut(){
    $(this).find(".sub").stop().fadeTo(0, 0, function() {
      $(this).hide();
      $("#nav-block").stop(true, true).delay(100).fadeOut();
    });
    
  }


  var config = {
    sensitivity: 1, // number = sensitivity threshold (must be 1 or higher)
    interval: 0, // number = milliseconds for onMouseOver polling interval
    over: megaHoverOver, // function = onMouseOver callback (REQUIRED)
    timeout: 0, // number = milliseconds delay before onMouseOut
    out: megaHoverOut // function = onMouseOut callback (REQUIRED)
  };

  $("#nav ul li .sub").css({
    'opacity':'0'
  });
  $("#nav ul li").hoverIntent(config);
  
  $('#slider-code').tinycarousel({ 
        controls: false, 
        interval: true,
        pager: true,
        animation: true 
  });
  
  
  // responsive table
  if($(window).width() <= 480){
  	$( "table" ).wrap( "<div class='table-responsive'></div>" );
  }

});

	
	
	
	
	
	
	
	
	
	